<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/lbg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">项目实施</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            项目的推进完成，更多的是其下的具体任务事项的协调安排以及建立任务负<br>责制；对任务
            进行分组，哪些是关键性的事情或者按照阶段划分；另外，<br>清晰的知道哪些任务延期了、
            哪些任务完成了，哪些任务出现了问题
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/l1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/licon1.png" alt="">
            </div>
            <div class="tip">
              我的项目
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立项目编号，便于后期统计项目成本
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/l2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/licon2.png" alt="">
            </div>
            <div class="tip">
              项目计划
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      用「甘特图」最直观地展现项目进度进展，
                      轻松设置任务依赖关系，不同的项目阶段、
                      任务、里程碑的时间节点都一目了然。无需
                      费时督促进展、频繁开会，管理者就能轻松
                      掌控项目
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/l3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/licon3.png" alt="">
            </div>
            <div class="tip">
              项目文档
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      建立团队统一的知识网盘，积累沉淀工作过
                      程中的知识经验，并可形成图纸归档，程序
                      归档
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/l4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/licon4.png" alt="">
            </div>
            <div class="tip">
              项目问题
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      风险点及项目点可视化，建立问题派发及
                      任务反馈机制，让每个问题都得到处理，
                      以免丢失或遗忘支持图、文、表和附件的
                      方式，描述问题和问题解决过程，更利于
                      发现和分析问题
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/l5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/licon5.png" alt="">
            </div>
            <div class="tip">
              项目采购
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      工程师BOM单个或者批量上传，便于查询
                      物料流转状态
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'ProjectStart',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
